module.exports = __webpack_public_path__ + "images/ic_person_add_white_24px.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ic_person_add_white_24px.svg
 ** module id = 59
 ** module chunks = 1
 **/